// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"f86c14bf","707":"381f8b96","729":"4e8e4552"}[chunkId] + ".js";
};